"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelButtonIcon = props => {
  const {
    showBrd = false,
    bgTransparent = false,
    className = null,
    disabled = false,
    ghost = false,
    icon,
    iconSize = 'normal',
    isLoading = null,
    label = '',
    onClick = null,
    onMouseEnter = null,
    onMouseLeave = null,
    padding = null,
    secondary = false,
    small = false,
    large = false,
    theme = 'primary',
    invert = false,
    themeSat = theme === 'text' ? 700 : 400,
    tooltipWidth = '',
    type = 'button'
  } = props;
  // CLASS LISTS
  const themeColor = theme ? `${theme.charAt(0).toUpperCase()}${theme.slice(1)}` : '';
  const classIsLoading = isLoading ? 'loading' : '';
  const hasLabel = label ? 'withLabel' : '';
  const variants = secondary ? 'secondary' : ghost ? 'ghost' : 'primary';
  let bgColors = bgTransparent ? 'bgTransparent' : `bg${themeColor}${themeSat}`;
  let txtColor = disabled ? 'txtWhite' : `txt${themeColor}${themeSat}`;
  let icnColor = disabled ? 'icnWhite' : `icn${themeColor}${invert ? 600 : themeSat}`;
  let brdColor = '';
  if (secondary && !disabled) {
    txtColor = themeColor === 'white' ? 'txtText900' : `txt${themeColor}${themeSat}`;
    icnColor = themeColor === 'white' ? 'icnText900' : `icn${themeColor}${themeSat}`;
  }
  if (!secondary && !bgTransparent && !ghost && !disabled) {
    txtColor = 'txtWhite';
    icnColor = 'icnWhite';
  }
  if (secondary || ghost) {
    if (invert) {
      bgColors = `bg${themeColor}100`;
    } else {
      bgColors = 'bgWhite';
    }
  }
  if (secondary && !disabled || showBrd && !disabled) {
    brdColor = `brd${themeColor}${themeSat} brdSmall ${themeColor === 'white' ? 'brdText900' : ''}`;
  }
  const isSmall = small ? 'small' : '';
  const isLarge = large ? 'large' : '';
  const loadingAnimClass = secondary || ghost ? `${themeColor}${themeSat}` : 'White';
  const txtColorClass = `${themeColor === 'White' ? 'White' : `${loadingAnimClass}`}`;
  const onClickBtn = e => {
    e.preventDefault();
    if (onClick && !disabled && !isLoading) onClick(e);
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    onClick: e => onClickBtn(e),
    onMouseEnter: e => onMouseEnter ? onMouseEnter(e) : '',
    onMouseLeave: e => onMouseLeave ? onMouseLeave(e) : '',
    className: `iconBtn ${txtColor} ${bgColors} ${icnColor} ${hasLabel} ${brdColor} ${classIsLoading} ${className} ${variants} ${isSmall} ${isLarge} ${disabled ? 'disabled' : ''}`,
    style: {
      padding: `${padding}px`
    },
    "aria-label": `Button ${icon}`,
    type: type
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: icon,
    iconSize: iconSize,
    className: "leftIcon"
  }), isLoading && (/*#__PURE__*/_react.default.createElement("div", {
    className: "btnLoader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "lds-ring"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${txtColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${txtColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${txtColorClass}`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `brdAni${txtColorClass}`
  })))), label && (/*#__PURE__*/_react.default.createElement("span", {
    className: "tooltipLabel fsize-200",
    style: {
      minWidth: `${tooltipWidth}px`
    }
  }, label)));
};
var _default = exports.default = BrixelButtonIcon;